var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaffIconforPfizerNotContacted4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 90,
    viewBox: "0 0 95 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 41.3C51.0751 41.3 56 35.6364 56 28.65C56 21.6636 51.0751 16 45 16C38.9249 16 34 21.6636 34 28.65C34 35.6364 38.9249 41.3 45 41.3Z",
    fill: "#734BD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7816 45.0987L53.7941 41.4688C53.1848 41.1916 52.4884 41.2659 51.9384 41.6637L50.1883 42.9352C47.1344 45.155 43.1397 45.1208 40.1191 42.8509L38.5616 41.6797C38.0172 41.2719 37.3208 41.1856 36.7078 41.4547L28.298 45.1248C26.1664 46.0549 24.6052 48.0778 24.1348 50.5185L23.0644 56.0808C22.6755 58.1017 24.0978 60 26.0016 60H63.9984C65.9022 60 67.3245 58.1017 66.9356 56.0808L65.8522 50.4522C65.3911 48.0496 63.8669 46.0489 61.7816 45.0987Z",
    fill: "#734BD1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 43.5,
    stroke: "#734BD1",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 16,
    r: 14.5,
    fill: "#BCBCBC",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2266 65.625V77H42.0703L37.2344 69.1094V77H35.0859V65.625H37.2344L42.0859 73.5234V65.625H44.2266ZM53.0703 73.2578H55.2188C55.1615 74.0182 54.9505 74.6927 54.5859 75.2812C54.2214 75.8646 53.7135 76.3229 53.0625 76.6562C52.4115 76.9896 51.6224 77.1562 50.6953 77.1562C49.9818 77.1562 49.3385 77.0312 48.7656 76.7812C48.1979 76.526 47.7109 76.1641 47.3047 75.6953C46.9036 75.2214 46.5964 74.6536 46.3828 73.9922C46.1693 73.3255 46.0625 72.5781 46.0625 71.75V70.8828C46.0625 70.0547 46.1719 69.3073 46.3906 68.6406C46.6094 67.974 46.9219 67.4062 47.3281 66.9375C47.7396 66.4635 48.2318 66.099 48.8047 65.8438C49.3828 65.5885 50.0286 65.4609 50.7422 65.4609C51.6693 65.4609 52.4531 65.6328 53.0938 65.9766C53.7344 66.3151 54.2318 66.7812 54.5859 67.375C54.9401 67.9688 55.1536 68.651 55.2266 69.4219H53.0781C53.0365 68.9427 52.9323 68.5365 52.7656 68.2031C52.6042 67.8698 52.3594 67.6172 52.0312 67.4453C51.7083 67.2682 51.2786 67.1797 50.7422 67.1797C50.3255 67.1797 49.9583 67.2578 49.6406 67.4141C49.3281 67.5703 49.0677 67.8047 48.8594 68.1172C48.651 68.4245 48.4948 68.8099 48.3906 69.2734C48.2865 69.7318 48.2344 70.263 48.2344 70.8672V71.75C48.2344 72.3281 48.2812 72.8464 48.375 73.3047C48.4688 73.763 48.6146 74.151 48.8125 74.4688C49.0104 74.7865 49.2656 75.0286 49.5781 75.1953C49.8906 75.362 50.263 75.4453 50.6953 75.4453C51.2214 75.4453 51.6484 75.362 51.9766 75.1953C52.3099 75.0286 52.5625 74.7839 52.7344 74.4609C52.9115 74.138 53.0234 73.737 53.0703 73.2578Z",
    fill: "#734BD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIconforPfizerNotContacted4);
export default __webpack_public_path__ + "static/media/Staff Icon for Pfizer - Not Contacted_4.0781fc2e84f60aa061474d9da91014e0.svg";
export { ForwardRef as ReactComponent };